import { makeStyles } from "@material-ui/core/styles";
import { ADMIN_COLORS } from "./adminTheme";

export const adminGlobalStyles = makeStyles(() => ({
  "@global": {
    ".admin-page-content": {
      backgroundColor: ADMIN_COLORS.pageBg,
    },
    ".admin-page-content .MuiCard-root": {
      borderRadius: 12,
      border: `1px solid ${ADMIN_COLORS.border}`,
      boxShadow: "none",
    },
    ".admin-page-content .MuiCard-root:hover": {
      boxShadow: "0 4px 16px rgba(242, 107, 29, 0.08)",
    },
    ".admin-page-content .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: ADMIN_COLORS.surface,
    },
    ".admin-page-content .MuiTableHead-root .MuiTableCell-head": {
      backgroundColor: ADMIN_COLORS.surfaceMuted,
      color: ADMIN_COLORS.textSecondary,
      fontSize: "0.75rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      borderBottom: `1px solid ${ADMIN_COLORS.border}`,
    },
    ".admin-page-content .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)": {
      backgroundColor: "#FCFCFD",
    },
    ".admin-page-content .MuiTableBody-root .MuiTableRow-root:hover": {
      backgroundColor: ADMIN_COLORS.surfaceMuted,
    },
    ".admin-page-content .MuiButton-contained": {
      borderRadius: 8,
      fontWeight: 600,
      boxShadow: "0 2px 8px rgba(15, 23, 42, 0.12)",
    },
    ".admin-page-content .MuiButton-outlined": {
      borderRadius: 8,
      fontWeight: 600,
      borderColor: ADMIN_COLORS.border,
    },
    ".admin-page-content .MuiPaper-elevation3, .admin-page-content .MuiPaper-elevation4": {
      boxShadow: "none",
      border: `1px solid ${ADMIN_COLORS.border}`,
      borderRadius: 12,
    },
  },
}));
